import script from "./UserEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEdit.vue?vue&type=script&setup=true&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=7c2d3b6b&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2d3b6b"]])

export default __exports__